import type { DamageInputs, DamageResult, RestraintBreakdown } from "../types";

export const BASE_CRITICAL_MULTIPLIER = 1.3;

const sum = (values: number[]) => values.reduce((total, value) => total + value, 0);

export function calculateDamage(
  input: DamageInputs,
  restraint: RestraintBreakdown,
): DamageResult {
  const baseDifference =
    input.attack * restraint.effectiveMultiplier - input.defense * (1 - input.penetration);
  const nonCritical =
    baseDifference *
    input.skillMultiplier *
    (1 + sum(input.aDamageIncrease) - sum(input.aDamageReduction)) *
    (1 + sum(input.bDamageIncrease) - sum(input.bDamageReduction)) *
    (1 + input.cDamageIncrease) *
    (1 - input.dDamageReduction);
  const criticalMultiplier =
    BASE_CRITICAL_MULTIPLIER + input.extraCriticalDamage - input.criticalDamageReduction;
  const critical = nonCritical * criticalMultiplier;

  return { baseDifference, nonCritical, critical, criticalMultiplier };
}

